export const LOAD_REQUEST = '@downloads/LOAD_REQUEST';
export const LOAD_SUCCESS = '@downloads/LOAD_SUCCESS';
export const LOAD_FAILURE = '@downloads/LOAD_FAILURE';
export const CHANGE_TYPE = '@downloads/CHANGE_TYPE';
